<mat-form-field appearance="outline" class="w-full" [floatLabel]="'always'">
  <mat-label *ngIf="displayLabel">{{ label }}</mat-label>
  <mat-select
    #matSelect
    disableOptionCentering
    [panelClass]="[
      (_currentThemeSubject | async) === 'dark' ? 'dark-theme-select-panel' : '',
      multiple ? 'multiple-custome-select-panel' : '',
      'custome-select-panel'
    ]"
    [required]="required"
    [formControl]="ngControl?.control"
    [fbDisableControl]="disable || readonly"
    [placeholder]="placeholder"
    [multiple]="multiple"
    [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
  >
    <mat-select-trigger
      *ngIf="multiple"
      class="counter-container t-body-text-regular"
      [class.dark-theme-color]="(_currentThemeSubject | async) === 'dark'"
      [class.light-theme-color]="(_currentThemeSubject | async) === 'light'"
    >
      <ng-container *ngIf="selectedOptions.length; else placeholder">
        <div class="selected-option">
          <span *ngFor="let option of selectedOptions; last as isLast">
            {{ option.label }}<span *ngIf="!isLast">, </span>
          </span>
        </div>
        <span
          class="counter"
          [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
          [class.light-theme]="(_currentThemeSubject | async) === 'light'"
        >
          {{ selectedCounter }}
        </span>
      </ng-container>
      <ng-template #placeholder>
        {{ placeholder || '' }}
      </ng-template>
    </mat-select-trigger>
    <div *ngIf="multiple && selectAll" class="d-flex pl-16 pr-16">
      <button class="add-item-button" (click)="toggleSelectAll()" matRipple>
        {{ selectAllButtonText }}
      </button>
    </div>
    <mat-option *ngFor="let option of options" [value]="option.value">
      <div class="d-flex">
        <div class="d-flex align-items-center" *ngIf="templates">
          <ng-container
            [ngTemplateOutlet]="[templates] | findTemplate : option.templateName"
            [ngTemplateOutletContext]="{
              $implicit: {
                config: option | transformFieldConfig : config
              }
            }"
          ></ng-container>
        </div>
        <span
          [ngStyle]="{ color: option.color }"
          [class.dark-theme-color]="(_currentThemeSubject | async) === 'dark'"
          class="t-body-text-regular d-flex align-items-center ml-8"
        >{{ option.label }}</span
        >
      </div>
    </mat-option>
  </mat-select>
  <button
    *ngIf="selectedCounter"
    tabindex="-1"
    type="button"
    mat-icon-button
    matSuffix
    class="clear-button"
    (click)="onClear(); onTouched(); $event.stopPropagation(); $event.preventDefault()"
    [disabled]="disable || readonly || ngControl.disabled"
  >
    <mat-icon [inline]="true" class="icon-button">clear</mat-icon>
  </button>
  <button
    type="button"
    mat-icon-button
    matSuffix
    (click)="
      matSelect.panelOpen ? matSelect.close() : matSelect.open(); $event.stopPropagation(); $event.preventDefault()
    "
    [disabled]="disable || readonly"
  >
    <ng-container *ngIf="!matSelect.panelOpen; else upIcon">
      <mat-icon [inline]="true" class="icon-button">keyboard_arrow_down</mat-icon>
    </ng-container>
    <ng-template #upIcon>
      <mat-icon [inline]="true" class="icon-button">keyboard_arrow_up</mat-icon>
    </ng-template>
  </button>
</mat-form-field>
